import { create } from 'zustand';
import api from '../lib/api';
import type { BackupChecksResponse } from '../types/admin';

interface AdminBackupsState {
  data: BackupChecksResponse | null;
  lastSuccessfulFetchAt: string | null;
  loading: boolean;
  error: string | null;
  fetch: () => Promise<void>;
  startPolling: () => void;
  stopPolling: () => void;
}

const POLL_INTERVAL_MS = 60_000;
let pollHandle: number | null = null;

export const useAdminBackupsStore = create<AdminBackupsState>((set, get) => ({
  data: null,
  lastSuccessfulFetchAt: null,
  loading: false,
  error: null,
  async fetch() {
    set({ loading: true });
    try {
      const res = await api.get<BackupChecksResponse>('/api/admin/backups/checks');
      set({
        data: res.data,
        loading: false,
        error: null,
        lastSuccessfulFetchAt: new Date().toISOString(),
      });
    } catch (err: unknown) {
      let message = 'Failed to load backup checks';
      if (typeof err === 'object' && err !== null) {
        const e = err as { response?: { data?: { message?: string } }; message?: string };
        message = e.response?.data?.message ?? e.message ?? message;
      }
      set({ loading: false, error: message });
    }
  },
  startPolling() {
    if (pollHandle !== null) return;
    pollHandle = window.setInterval(() => {
      void get().fetch();
    }, POLL_INTERVAL_MS);
  },
  stopPolling() {
    if (pollHandle !== null) {
      window.clearInterval(pollHandle);
      pollHandle = null;
    }
  },
}));
